import React from "react";

import { Row, Col, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import LazyLoad from 'react-lazyload';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Books/Books.css";

const bookCard = {
  borderRadius: "10px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  margin: "15px",
};

const BooksInsideSimilar = (props) => {
  return props.size === "laptopdesktop" ? (
    <div style={{ backgroundColor: "#fff" }}>
      <Row>
        <Col
          span={24}
          style={{
            direction: "rtl",
            textAlign: "right",
            backgroundColor: "#fff",
            opacity: "90%",
            borderRadius: "20px",
          }}
        >
          <Center>
            <Margin top={5}>
              <div>
                <p className="subTitleTablet"><strong>کتاب های مشابه</strong></p>
              </div>
            </Margin>
          </Center>
          <Center>
            <hr className="subTitleHRTablet" />
          </Center>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={2}></Col>
                {props.books.map((item, index) => {
                  return [
                    <Col span={4} key={item.id}>
                      <a onClick={()=>props.history.push(`/booksinside/${item.id}`)} >
                        <Card style={bookCard}>
                          <LazyLoad>
                            
                          
                          <Center>
                            <img style={{ width: "100%" }} src={item.image} />
                          </Center>
                          </LazyLoad>
                        </Card>
                        <Center>
                          <p className="textParagraph" style={{ textAlign: "center" }}>{item.title}</p>
                        </Center>
                      </a>
                    </Col>,
                  ];
                })}

                <Col span={2}></Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
      <div style={{ backgroundColor: "#fff" }}>
        <Row>
          <Col
            span={24}
            style={{
              direction: "rtl",
              textAlign: "right",
              backgroundColor: "#fff",
              opacity: "95%",
              borderRadius: "20px",
            }}
          >
            <Center>
              <Margin top={4}>
                <div>
                  <p className="subTitleTablet">
                    <strong>
                      کتاب های مشابه
              </strong>
                  </p>
                </div>
              </Margin>
            </Center>
            <Center>
              <hr className="subTitleHRTablet" />
            </Center>
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={3}></Col>
                  {props.books.map((item, index) => {
                    return [
                      <Col span={6} key={item.id}>
                        <a onClick={() => props.history.push(`/booksinside/${item.id}`)} >
                          <Card style={bookCard}>
                            <LazyLoad>
                            <Center>
                              <img style={{ width: "100%" }} src={item.image} />
                            </Center>
                              </LazyLoad>
                          </Card>
                          <Center>
                            <p className="textParagraphTablet" style={{ textAlign: "center" }}>{item.title}</p>
                          </Center>
                        </a>
                      </Col>,
                    ];
                  })}

                  <Col span={3}></Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
  ) : (
        <div style={{ backgroundColor: "#fff" }}>
          <Row>
            <Col
              span={24}
              style={{
                direction: "rtl",
                textAlign: "right",
                backgroundColor: "#fff",
                opacity: "95%",
                borderRadius: "20px",
              }}
            >
              <Center>
                <Margin top={4}>
                  <div>
                    <p className="subTitleMobile">
                      <strong>
                        کتاب های مشابه
                  </strong>
                    </p>
                  </div>
                </Margin>
              </Center>
              <Center>
                <div className="subTitleHRMobile"></div>
              </Center>
              <Row>
                <Col span={24}>
                  <Row>
                    {props.books.map((item, index) => {
                      return [
                        <Col span={12} key={item.id}>
                          <a onClick={() => props.history.push(`/booksinside/${item.id}`)} >
                            <Card style={bookCard}>
                              <LazyLoad>
                              <Center>
                                <img style={{ width: "100%" }} src={item.image} />
                              </Center>
                                </LazyLoad>
                            </Card>
                            <Center>
                              <p className="textParagraphMobile" style={{ textAlign: "center" }}>{item.title}</p>
                            </Center>
                          </a>
                        </Col>,
                      ];
                    })}

                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
  );
};

export default BooksInsideSimilar;
